import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../styles/common.css";
import "../styles/legal.css";

const Agb = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='agb'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/">Home</a></li>
                <li aria-current="page">Allgemeine Geschäftsbedingungen (AGB)</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='legal'>
          <div className='legal-box'>
            <h2>1. Geltungsbereich</h2>
            <div className='legal-box__text'>
              <p>Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen <b>LOGOT UG</b> (nachfolgend „Anbieter“ genannt) und den Kunden (nachfolgend „Kunde“ genannt) abgeschlossen werden.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>2. Vertragsschluss</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Die Darstellung unserer Dienstleistungen auf der Website stellt kein rechtlich bindendes Angebot dar, sondern eine unverbindliche Einladung zur Abgabe eines Angebots durch den Kunden.</li>
                <li>Ein Vertrag kommt erst durch unsere ausdrückliche Annahme oder durch die Erbringung der Leistung zustande.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>3. Leistungen</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Der Anbieter erbringt Dienstleistungen im Bereich [Webentwicklung/Design, IT-Services etc.].</li>
                <li>Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Vertrag oder Angebot.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>4. Preise und Zahlungsbedingungen</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Die angegebenen Preise verstehen sich in Euro zzgl. der gesetzlichen Mehrwertsteuer, sofern nicht anders angegeben.</li>
                <li>Zahlungen sind, sofern nicht anders vereinbart, innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug fällig.</li>
                <li>Bei Zahlungsverzug behalten wir uns das Recht vor, Verzugszinsen in gesetzlicher Höhe zu berechnen.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>5. Mitwirkungspflichten des Kunden</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Der Kunde ist verpflichtet, alle erforderlichen Informationen und Unterlagen rechtzeitig bereitzustellen.</li>
                <li>Verzögerungen, die durch fehlende Mitwirkung des Kunden entstehen, verlängern die Leistungsfristen entsprechend.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>6. Haftung und Gewährleistung</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Der Anbieter haftet nur für Vorsatz und grobe Fahrlässigkeit.</li>
                <li>Eine weitergehende Haftung ist ausgeschlossen, soweit gesetzlich zulässig.</li>
                <li>Der Kunde hat etwaige Mängel unverzüglich anzuzeigen.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>7. Urheberrecht und Nutzungsrechte</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Alle erstellten Inhalte, Designs und Softwarelösungen bleiben bis zur vollständigen Bezahlung unser Eigentum.</li>
                <li>Eine Nutzung oder Weitergabe an Dritte ist ohne unsere ausdrückliche Zustimmung nicht gestattet.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>8. Vertragsdauer und Kündigung</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Verträge werden für die in der Vereinbarung festgelegte Dauer abgeschlossen.</li>
                <li>Eine Kündigung bedarf der Schriftform.</li>
              </ol>
            </div>
          </div>
          <div className='legal-box'>
            <h2>9. Datenschutz</h2>
            <div className='legal-box__text'>
              <p>Unsere Datenschutzbestimmungen sind in der <a href="/datenschutzerklarung" className='button-underLine'>Datenschutzerklärung</a> einsehbar.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>10. Schlussbestimmungen</h2>
            <div className='legal-box__text'>
              <ol className='list-parentheses'>
                <li>Es gilt das Recht der Bundesrepublik Deutschland.</li>
                <li>Erfüllungsort und Gerichtsstand ist [Ihr Standort], sofern der Kunde Kaufmann ist.</li>
                <li>Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Gültigkeit der übrigen Bestimmungen unberührt.</li>
              </ol>
              <p><b>Letzte Aktualisierung: 01.03.2025</b></p>
            </div>
          </div>
        </section>

      </main >
      <Footer></Footer>
    </>
  );
};

export default Agb